import { createStyles, rem } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  backAllClients: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    gap: "1rem",
  },
  facilityBox: {
    border: "1px solid var(--app-border)",
    padding: ".5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginLeft: "4rem",
    "@media (max-width: 768px)": {
      marginLeft: 0,
    },
  },
  facilityContainer: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  facility: {
    backgroundColor: "var(--app-surface-2)",
    padding: "1px 5px",
    margin: "0 5px",
    borderRadius: "8px",
    fontFamily: "Inter",
    display: "inline-block",
  },
  leftSide: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  rightIcons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "1rem",
  },
  myfont: {
    fontFamily: "Inter",
    fontSize: rem(26),
    fontWeight: 600,
    marginLeft: 10,
    float: "left",
    "@media (max-width: 600px)": {
      fontSize: rem(20),
    },
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 54,
    width: "100%",
    "& .mantine-puhs6b:hover": {
      backgroundColor: "none !important",
    },
    "@media (max-width: 768px)": {
      flexDirection: "column",
      alignItems: "flex-start",
      marginTop: 20,
      gap: "0.5rem",
    },
  },
  float_right: {
    float: "right",
  },
  colorChangeActive: {
    backgroundColor: "var(--app-primary)",
    color: "var(--app-on-primary)",
  },
  mobileScreen: {
    width: "50%",
    margin: "0", // Set the default margin to 0
    "@media (max-width :80em)": {
      width: "100%",
      fontFamily: "Inter",
      margin: "1rem 0", // Adjust the margin for mobile screens
    },
  },
  changeColor: {
    background: "var(--app-surface-2)",
    padding: "1rem",
    width: "52px",
    height: "52px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  changeIconColor: {
    display: "flex",
    width: "30px",
    height: "30px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
    color: "var(--app-text)",
  },
  settingBGcolor: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
    borderRadius: "12px",
    background: "var(--app-surface-2)",
    width: "52px",
    height: "52px",
    cursor: "pointer",
    margin: "0 5px",
  },
  settingIcon: {
    color: "var(--app-text)",
    display: "flex",
    width: "30px",
    height: "30px",
    justifyContent: "center",
    alignItems: "center",
  },
  badge: {
    position: "absolute",
    top: -10,
    right: -10,
    background: "var(--app-primary)",
    color: "var(--app-on-primary)",
    borderRadius: "50%",
    width: 20,
    height: 20,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: "bold",
    fontSize: "14px",
  },

  bellMarginRight: {
    marginRight: "20px",
  },
  clickedBell: {
    backgroundColor: "var(--app-primary)",
    padding: "10px 12px",
    borderRadius: "10px",
  },
  avatarBorderRadius:{
    borderRadius:"15px"
  }

  // tabs: {
  //   "& .mantine-Tabs-tab[aria-selected='true']": {
  //     background: "#f4ead8 !important",
  //   },
  //   "& .mantine-Tabs-tabsList": {
  //     flexWrap: "nowrap !important",
  //     overflowX: "auto !important",
  //     paddingBottom: "1rem !important",
  //   },
  //   "& .mantine-cohod4": {
  //     gap: "0rem",
  //   },
  //   backgroundColor: "#fff",
  //   margin: "1rem",
  // },
  // tab: {
  //   // padding: "1rem 1rem",
  //   backgroundColor: "#fff",
  //   marginRight: "1rem",
  // },
  // tabList: {
  //   backgroundColor: "#F2F2F2",
  // },
  // tabTitle: {
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "center",
  //   gap: ".5rem",
  // },
  // formContent: {
  //   display: "flex",
  //   alignItems: "start",
  //   justifyContent: "start",
  //   gap: "1rem",
  //   width: "100%",
  //   backgroundColor: "red",
  //   margin: "0 !important",
  //   "@media (max-width :500px)": {
  //     flexDirection: "column",
  //   },
  // },
  // formInfo: {
  //   backgroundColor: "#fff",
  //   width: "100px",
  //   "@media (max-width :500px)": {
  //     width: "100% !important",
  //     maxWidth: "100% !important",
  //   },
  // },
}));
export default useStyles;
